import styled from "styled-components";
import { RiCheckboxCircleFill } from "react-icons/ri";
import { Box, Flex } from "rebass/styled-components";

import { InputText } from "../Inputs";
import { Body } from "../Text";

export const SharecodeLink = styled(Body)`
  color: ${(props) => props.theme.colors.chalk};
  width: fit-content;
  border-bottom: 1px solid ${(props) => props.theme.colors.envy};
  margin: 6px 0;
  &:hover {
    cursor: pointer;
    color: ${(props) => props.theme.colors.envy};
    transition: 0.2s;
  }
`;

export const ChecklistContainer = styled(Flex)`
  background: ${(props) => props.theme.colors.midnightAlpha40};
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-top: 30px;
  justify-content:;
  align-items: start;
  border-radius: 16px;
  flex-direction: column;
  @media (max-width: ${(props) => props.theme.breaks.standard}) {
    margin-top: 15px;
  }
`;

export const SharecodeContainer = styled(Flex)`
  flex-direction: column;
  width: 100%;
`;

export const InputContainer = styled(Flex)`
  height: 100%;
  width: 100%;
`;

export const StyledInput = styled(InputText)`
  font-family: "Cutive Mono", monospace;
  color: ${({ theme }) => theme.colors.envy};
`;

export const StyledCheckIcon = styled(RiCheckboxCircleFill)`
  color: ${(props) => props.theme.colors.envy};
  width: 24px;
  height: 24px;
  padding-right: 10px;
  flex-shrink: 0;
`;

export const ListItem = styled(Flex)`
  flex-direction: row;
  align-items: flex-start;
`;

export const InputLabel = styled(Body)``;

export const ErrorText = styled.p`
  color: ${(props) => props.theme.colors.alert};
`;
